// extracted by mini-css-extract-plugin
module.exports = {"Panel":"nl_a pz_cv pz_je pz_iu pz_nz pz_ru"};